/* eslint-disable max-lines */
import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import WorkQueues from 'enums/workQueue.enum';
import { listProcessedExternalOrdersByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import ProcessedExternalOrdersTable from './ProcessedExternalOrdersTable';
import ProcessedExternalOrdersFilterButton from './ProcessedExternalOrdersFilterButton';
import ProcessedExternalOrdersFilterStatusBar from './ProcessedExternalOrdersFilterStatusBar';

const ProcessedExternalOrders = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(
    ({ workQueue }) => workQueue.processedExternalOrders,
    shallowEqual
  );
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.PROCESSED_EXTERNAL_ORDERS)) {
      dispatch(listProcessedExternalOrdersByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.PROCESSED_EXTERNAL_ORDERS) return null;

  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <ProcessedExternalOrdersFilterStatusBar />
      </Grid>
      <Grid item>
        <ProcessedExternalOrdersFilterButton />
      </Grid>
      <ProcessedExternalOrdersTable />
    </Grid>
  );
};

export default ProcessedExternalOrders;
